import { Close } from "@material-ui/icons";
import { ThumbsUp } from "lucide-react";
import React from "react";
import './index.css'
import BundleCard from "components/Bundles/BundleCard";

const getDialogClass = (length) => {
  if (length === 1) return 'single';
  if (length === 2) return 'doubles';
  return '';
};

export default function BundleDialog(props) {
  const {
    onClose,
    title,
    subtitle,
    suggestTitle,
    image,
    // suggestMessage,
    items,
    onSelectBundlePack,
    selectedBundle
  } = props;

  const cardClassName = getDialogClass(items.length)

  return (
    <>
      <div className="dialog-overlay" onClick={onClose} aria-hidden="true" />

      <section className={`dialog ${cardClassName}`} role="dialog" aria-modal="true">
        <div>
          <div className="dialog-header">
            {image && <img src={image} />}
            <h2>{title}</h2>
          </div>
          <h3 dangerouslySetInnerHTML={{__html: subtitle}} />
        </div>

        <div className="dialog-body">
          {items.map((item, i) => {
            return (
              <BundleCard
                key={`${item.code}-${i}`} 
                item={item}
                onClick={() => onSelectBundlePack(item.id)}
                isSelected={
                  selectedBundle ? item.id === selectedBundle.id : false
                }
                className={cardClassName}
              />
            )})}
        </div>

        <div className="dialog-banner">
          <ThumbsUp />
          <div dangerouslySetInnerHTML={{__html: suggestTitle}} />
        </div>

        <button onClick={onClose} className="dialog-close-button" aria-label="Chiudi">
          <Close />
        </button>
      </section>
    </>
  );
}
